import { Model, View } from '@lernetz/ts-lib';
import { context } from '@lernetz/ts-lib/src/view/Template';

import imageTemplate from './Image.html';


export class Image extends Model {

    public readonly alt?: string;
    public readonly description: string;
    public readonly image: any;
    public readonly marginTop: string;
    public readonly marginBottom: string;
    public readonly maxHeight: number | null;
    public readonly style: string;
    public readonly width: string;

    constructor(dto) {
        super({
            alt: '',
            description: '',
            maxHeight: null,
            marginTop: '',
            marginBottom: '',
            style: '',
            width: '',
            ...dto
        });
    }

    public get hasBackground(): boolean {
        return this.style.includes('-with-background');
    }
}


export class ImageView extends View<Image> {

    constructor() {
        super({ template: imageTemplate });
    }

    init() {
        const hasImage = !!this.data.image;
        if (hasImage) {
            const imageNode = <HTMLImageElement> this.node.querySelector('[js="image"]');
            imageNode.src = context.imagePath(this.data.image, 'medium');

            if (this.data.maxHeight) {
                imageNode.style.maxHeight = `${this.data.maxHeight / 16}rem`;
            }

            const hasDescription = this.data.description && this.data.description !== '<p></p>';
            if (hasDescription) {
                this.node.querySelector('[js="description"]').innerHTML = this.data.description;
                this.node.querySelector('.caption').classList.remove('-hidden');
            }
        }
    }
}
